import React from "react";
import ReactDOM from "react-dom/client";
import "./styles.css";
import App from "./App";
import {
  BrandVariants,
  createLightTheme,
  FluentProvider,
  Theme
} from "@fluentui/react-components";

const sK: BrandVariants = {
  10: "#020508",
  20: "#0A1929",
  30: "#0E2740",
  40: "#123557",
  50: "#16436E",
  60: "#1A5285",
  70: "#1E609C",
  80: "#226EB3",
  90: "#2B7DC7",
  100: "#388CDB",
  110: "#4A9BED",
  120: "#66ABF2",
  130: "#82BBF5",
  140: "#9ECBF8",
  150: "#BADBFB",
  160: "#D6EBFD"
};
const skTheme: Theme = {
  ...createLightTheme(sK)
};
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <FluentProvider theme={skTheme}>
    <App />
  </FluentProvider>
);
